import { useState } from 'react';
import PropTypes from 'prop-types';

const WhyAvexaSection = ({ 
  title, 
  highlightedText, 
  description, 
  visionItems,
  // backgroundColor = '#f7fafc'  
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Calculate total pages (each page shows 2 items)
  const itemsPerPage = 2;
  const totalPages = Math.ceil(visionItems.length / itemsPerPage);
  const showArrows = visionItems.length > itemsPerPage;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? totalPages - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= totalPages - 1 ? 0 : prev + 1));
  };

  const getCurrentItems = () => {
    const startIndex = currentIndex * itemsPerPage;
    return visionItems.slice(startIndex, startIndex + itemsPerPage);
  };

  const currentItems = getCurrentItems();

  return (
    <section className="py-14 md:py-18">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className=" font-bold text-gray-800 mb-6">
            <span className=''>Why{' '}</span>
            <span className='secondary-text'>
              {highlightedText}
            </span>{' '}
            <span className=''>{title}</span>
          </h2>
          <p className="   leading-relaxed">
            {description}
          </p>
        </div>

        {/* Carousel Container */}
        <div className="max-w-6xl mx-auto">
          <div
            className="relative rounded-xl px-4 md:px-16 lg:px-20 py-6 md:py-10 shadow-lg blue-bg"
          >
            {/* Left Arrow */}
            {showArrows && (
              <button
                onClick={handlePrev}
                className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-gray-700 hover:bg-gray-600 rounded-full p-2 transition-all z-10"
                aria-label="Previous"
              >
                <img src='/assets/images/platform-left-arrow.svg' alt="Previous" className="w-5 h-5 invert" />
              </button>
            )}

            {/* Content Container - Only show current 2 items */}
            <div className="relative px-6 md:px-10">
              {/* Center Divider */}
              {currentItems.length === 2 && (
                <div className="hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-24 w-px primary-bg opacity-70" />
              )}
  
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-24 min-h-[180px]">
                {currentItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center"
                  >
                    <div className="text-center max-w-md">
                      <h3 className="font-bold  mb-3">
                        {item.title}
                      </h3>
                      <p className="   leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow - Always visible */}
            {showArrows && (
              <button
                onClick={handleNext}
                className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-gray-700 hover:bg-gray-600 rounded-full p-2 transition-all z-10"
                aria-label="Next"
              >
                <img src='/assets/images/paltform-right-arrow.svg' alt="Next" className="w-5 h-5 invert" />
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

WhyAvexaSection.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  visionItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
};

export default WhyAvexaSection;